
import UITrendingStockWidget from '~/components/ui/widgets/symbol/UITrendingStockWidget.vue';
import { mapActions, mapGetters } from 'vuex';
import { TrendingTickerType } from '~/utils/constants/trendingTickerTypes';

export default {
  Name: 'TrendingGainersTickersWidgetWrapper',
  components: { UITrendingStockWidget },
  props: {
    limit: {
      type: Number,
      default: 5,
    },
  },
  async fetch() {
    if (process.client) {
      if (!this.trendingGainersTickersRes.data) {
        await this.getTrendingTickers({
          limit: this.limit,
          trendingType: TrendingTickerType.GAINERS,
          type: 0,
        });
      }
    }
  },
  computed: {
    ...mapGetters('trendingTickersWidget', ['trendingGainersTickersRes']),
    tickersList() {
      return this.trendingGainersTickersRes.data;
    },
  },
  methods: {
    ...mapActions('trendingTickersWidget', ['getTrendingTickers']),
  },
};
